<template>
  <div class="current-request-top">
    <card-header :title="title" />
    <template v-if="topConfig && topConfig.data">
      <auto-scroll-table v-bind="$attrs" :config="topConfig" style="width:100%;height:310px;" />
    </template>
  </div>
</template>
<script>
import CardHeader from './card-header.vue';
import AutoScrollTable from './auto-scroll-table.vue';

export default {
  components: {
    CardHeader,
    AutoScrollTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      topConfig: {},
    };
  },
  watch: {
    data(val) {
      this.topConfig = {
        // align: ['center', 'left', 'center'],
        align: ['left', 'center'],
        data: val,
        // header: ['排名', '接口地址', '数量'],
        header: ['接口地址', '数量'],
        index: false, // 是否显示序号
        indexHeader: '', // 序号列表头文字
        rowNum: 10, // 显示行数
        headerHeight: 25, // 表头高度
        headerFontSize: 14, // 表头文字大小
        columnFontSize: 14, // 表格文字大小
        columnMarginTop: 10, // 表格与表头距离
        columnMarginRight: 0, // 表格与表头距离
        // columnWidth: [48, 700, 100], // 列宽
        columnWidth: [750, 150], // 列宽
        // columnPaddingLeft: [0, 7, 35], // 左padding
        columnPaddingLeft: [10, 30], // 左padding
        autoPlay: true, // 是否自动播放
        columnStyle: [
          // { 'padding-left': '20px', width: '200px', color: 'pink' },
          // { 'padding-left': '300px', width: '200px', 'font-weight': 'bold' },
          // { 'font-weight': 'bold', color: '#FED762' },
          // { 'font-weight': 'bold', color: '#11F8DE' },
          // { 'font-weight': 'bold', color: '#32C5FF' },
        ], // 表格第一列样式
      };
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.current-request-top {
  height: 376px;
  // width: 100%;
  // width: 695px;
  flex: 1;
  width: 0;
  box-sizing: border-box;
  padding: 12px 14px;
  background-image: url("../../../assets/screen-adapter/最近7天供应商排名统计.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
